import axiosInstance from '@/utils/axiosInstance.js'
import SERVICES from '@/utils/servicesUtil.js'

//#region EMAIL
const getTemplate = (organizationId, templateId) => axiosInstance.get(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}/${templateId}`)
const createTemplate = (organizationId, body) => axiosInstance.post(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}`, body)
const updateTemplate = (organizationId, templateId, body) =>
  axiosInstance.post(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}/${templateId}/html-builder`, body)
const uploadImageHtmlBuilder = (organizationId, templateId, body) =>
  axiosInstance.post(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}/${templateId}/html-builder/upload`, body)
const templatesEmail = (organizationId, params) => axiosInstance.get(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}/organization`, params)
const sendTemplatesEmail = (organizationId, formdata) => axiosInstance.post(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}`, formdata)
const deleteTemplatesEmail = (organizationId, body) => axiosInstance.delete(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}`, body)
const uploadImageTemplateGrapes = (organizationId, templateId, formdata) =>
  axiosInstance.post(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}/${templateId}/grapesjs/upload`, formdata)
const sendSimpleText = (organizationId, templateId, body) =>
  axiosInstance.patch(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}/${templateId}/simple-text`, body)
const updateTemplateEmail = (organizationId, templateId, body) =>
  axiosInstance.put(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}/${templateId}`, body)
const duplicateEmail = (organizationId, templateId) => axiosInstance.get(`${SERVICES.TEMPLATE_EMAIL}/${organizationId}/duplicate/${templateId}`)

//#endregion

//#region DEFAULT EMAIL

const getDefaultTemplate = (defaultTemplateId) => axiosInstance.get(`${SERVICES.TEMPLATE_DEFAULT_EMAIL}/${defaultTemplateId}`)

//#endregion

//#region SMS
const templatesSMS = (organizationId, params) => axiosInstance.get(`${SERVICES.TEMPLATE_SMS}/${organizationId}/organization`, params)
const createTemplatesSMS = (organizationId, body) => axiosInstance.post(`${SERVICES.TEMPLATE_SMS}/${organizationId}`, body)
const deleteTemplatesSMS = (organizationId, body) => axiosInstance.delete(`${SERVICES.TEMPLATE_SMS}/${organizationId}`, body)
const updateTemplatesSMS = (organizationId, body, templateSmsId) =>
  axiosInstance.patch(`${SERVICES.TEMPLATE_SMS}/${organizationId}/${templateSmsId}`, body)
const getTemplateSMS = (organizationId, templateSmsId) => axiosInstance.get(`${SERVICES.TEMPLATE_SMS}/${organizationId}/${templateSmsId}`)
const getTemplateSMSOrganization = (organizationId) => axiosInstance.get(`${SERVICES.TEMPLATE_SMS}/${organizationId}/organization`)
//#endregion

export default {
  //#region EMAIL
  getTemplate,
  createTemplate,
  updateTemplate,
  uploadImageHtmlBuilder,
  templatesEmail,
  sendTemplatesEmail,
  deleteTemplatesEmail,
  sendSimpleText,
  updateTemplateEmail,
  uploadImageTemplateGrapes,
  duplicateEmail,
  //#endregion

  //#region DEFAULT EMAIL
  getDefaultTemplate,
  //#endregion

  //#region SMS
  templatesSMS,
  createTemplatesSMS,
  deleteTemplatesSMS,
  updateTemplatesSMS,
  getTemplateSMS,
  getTemplateSMSOrganization,
  //#endregion
}
